<template>
  <collapse :title="'totals'">
    <b-table
      :data="totals"
      :striped="true"
      :mobile-cards="false"
      :narrowed="true"
      :loading="loading"
    >
      <template slot-scope="props">
        <b-table-column field="name" :label="$t('transaction.name')">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="amount" :label="$t('transaction.amount')">
          {{ props.row.amount }}
        </b-table-column>
      </template>

      <template slot="footer">
        <div class="has-text-right">
          <b-tag size="is-medium" :type="getType">{{ total }}</b-tag>
        </div>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="frown" size="is-large"> </b-icon>
            </p>
            <p>
              <i18n path="table.noTotalsTracked">
                {{ $t("table.totals") }}
              </i18n>
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </collapse>
</template>

<script>
import Collapse from "@/components/Collapse.vue";

export default {
  name: "totalsTable",
  components: {
    Collapse
  },
  props: {
    totals: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    total() {
      return this.totals[0].amount - this.totals[1].amount;
    },
    getType() {
      return this.total > 0 ? "is-success" : "is-danger";
    }
  }
};
</script>
